import React from 'react';
import { formatTranslation } from 'intl';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import { useBacktrack } from 'components/common/withBacktrack';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { withProcessesData } from 'components/common/withProcessesData';
import { MemoLongCompanyForm } from 'components/company/Form';
import {
  useCreateCompany,
  withCreateCompany,
} from 'components/dataCreationForms/company/withCreateCompany';
import { WithInputForm } from 'components/dataCreationForms/withInputForm';
import { useFormCleanupOnUnmount } from 'presentation/dialogForms/dialogFormsHooks';
import { useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import { CompanyWizardPage } from '../presentational';

function CreateCompanyWizardContainer(): React.ReactElement {
  const {
    submitForm,
    isPosting,
    initialValues,
    releaseSubmitEvent,
    SUBMIT_EVENT_TYPE,
    handleFormValidation,
    validate,
    availableSites,
  } = useCreateCompany();
  const intl = useIntl();

  const { back } = useBacktrack();
  const formName = 'company';
  useFormCleanupOnUnmount(formName);
  const onCancel = useCallback(() => {
    back();
  }, [back]);

  return (
    <WithInputForm
      values={initialValues}
      errors={{}}
      handleFormValidation={handleFormValidation}
      handleFieldValidation={validate}
      onSubmit={submitForm}
      eventType={SUBMIT_EVENT_TYPE}
      dispatchSubmit={releaseSubmitEvent}
      formName={formName}
    >
      <CompanyWizardPage
        title={formatTranslation(intl, ProjectSetupTranslationKeys.addCompanySection)}
        isPosting={isPosting}
        onSubmit={releaseSubmitEvent}
        onCancel={onCancel}
      >
        <MemoLongCompanyForm
          disableInvolvement={false}
          sites={availableSites}
          isDialog={false}
          initialValues={initialValues}
        />
      </CompanyWizardPage>
    </WithInputForm>
  );
}

export const MemoCreateCompanyWizardContainer = memo(
  composeHOCs(withProcessesData, withCreateCompany)(
    CreateCompanyWizardContainer
  )
);
